module.exports = __webpack_public_path__ + "img/product-program-yszc-icon4.813f4cc6.png";